import { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyButtons from "./components/StickyButtons";
import LeadDialog from "./components/LeadDialog";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import PropertiesPage from "./pages/PropertiesPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  const [leadOpen, setLeadOpen] = useState(false);
  const openLead = () => setLeadOpen(true);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="App relative min-h-screen bg-[#050505] text-white">
      {!isAdmin && <Header onOpenLead={openLead} />}
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<HomePage onOpenLead={openLead} />} />
          <Route path="/about" element={<AboutPage onOpenLead={openLead} />} />
          <Route
            path="/services"
            element={<ServicesPage onOpenLead={openLead} />}
          />
          <Route
            path="/projects"
            element={<ProjectsPage onOpenLead={openLead} />}
          />
          <Route
            path="/projects/:slug"
            element={<ProjectDetailPage onOpenLead={openLead} />}
          />
          <Route
            path="/properties"
            element={<PropertiesPage onOpenLead={openLead} />}
          />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage onOpenLead={openLead} />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyButtons onOpenLead={openLead} />}
      <LeadDialog open={leadOpen} onOpenChange={setLeadOpen} />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
